import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSpecificParams } from "@/utils/hooksUtils";
import { useGetAgentTree } from "../../../common/api/queries";
import { DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS } from "../api";
import { AgentTreeFilterForm } from "../components/forms/AgentTreeFilterForm";
import { AgentTreeView } from "../components/tree/AgentTreeView";
import { AgentTreeFilterRequest } from "../types";

export const AgentTreeContainer = () => {
  const searchParams = useFilterSpecificParams<AgentTreeFilterRequest>(
    ["includeDeactivated", "includeRepresentatives", "rootAgentId"],
    DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS,
  );

  const { data, isError } = useGetAgentTree(searchParams);

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!data} isError={isError}>
        <AgentTreeFilterForm searchParams={searchParams} />

        {data ? <AgentTreeView agentTree={data} searchParams={searchParams} /> : undefined}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
